import { Utils } from "@/plugins/utils"
import router from "@/router"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstMpv: [],
		lstLeases: [],
		mpvLstCli: [],
		mpvLstAddressGroups: [],
		mpvLstShippingAddresses: [],
		leaseFilterOptions: {
			customers: {},
			addressGroups: {},
			shippingAddresses: {},
		},
		mpv: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 999,
		search: "",
		cv5cliente: "",
		cf1repres: "",
		cf1tipo: "",
		sinceEmit: "",
		untilEmit: "",
		sinceDateVigen: moment().subtract(1, "month").format("YYYY-MM-DD"),
		untilDateVigen: moment().format("YYYY-MM-DD"),
		hasNext: false,
		lastUpdatedRegister: null,
		pending: false,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getMpv(state) {
			let mpv = { ...state.mpv }
			return mpv
		},
		getMpvid(state) {
			return state.mpv.mpvid
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, mpv) {
			state.mpv = mpv
			if (mpv) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.mpv = null
		},
		setParamsDataTable(state, payload) {
			state.lstLeases = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
			state.leaseFilterOptions = {
				customers: payload.customers || {},
				addressGroups: payload.addressGroups || {},
				shippingAddresses: payload.shippingAddresses || {},
			}
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setMpv(state, mpv) {
			state.mpv = mpv
		},
		setLstMpv(state, lstMpv) {
			state.lstMpv = lstMpv
		},
		setLstLeases(state, lstLeases) {
			state.lstLeases = lstLeases
		},
		setMpvLstCli(state, mpvLstCli) {
			state.mpvLstCli = mpvLstCli
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, mpvid) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/TermsOfValidity/Find/${mpvid}`)
				.then(response => {
					let mpv = Utils.ValidateAxiosResponse(response.data)
					commit("set", mpv)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			let payload = await this._vm.$axios
				.post("/Financial/TermsOfValidity/Insert", getters.getMpv)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setMpv", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async update({ commit, getters, dispatch }) {
			let payload = await this._vm.$axios
				.put("/Financial/TermsOfValidity/Update", getters.getMpv)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async findTerms({ dispatch, commit }) {
			return await this._vm.$axios
				.get("/Financial/LeaseDocument/FindTerms")
				.then(response => {
					let lstMpv = Utils.ValidateAxiosResponse(response.data)
					commit("setLstMpv", lstMpv)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
		async search({ commit, dispatch, state }, { since = null, until = null, limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			let url = `/Financial/LeaseDocument/Search?limit=${limit}&page=${page}`

			if (state.cf1tipo && state.cf1tipo != "") {
				url += `&cf1tipo=${state.cf1tipo}`
			}
			if (state.cf1repres && state.cf1repres != "") {
				url += `&cf1repres=${state.cf1repres}`
			}
			if (state.sinceEmit) {
				url += `&sinceEmit=${state.sinceEmit}`
			}
			if (state.untilEmit) {
				url += `&untilEmit=${state.untilEmit}`
			}
			if (since) {
				url += `&since=${since}`
			}
			if (until) {
				url += `&until=${until}`
			}
			if (state.mpvLstCli.length > 0) {
				state.mpvLstCli.forEach(cliente => {
					url += `&lstClientes=${encodeURIComponent(cliente)}`
				})
			}
			if (state.mpvLstAddressGroups.length > 0) {
				state.mpvLstAddressGroups.forEach(addressGroup => {
					url += `&lstAddressGroups=${encodeURIComponent(addressGroup)}`
				})
			}
			if (state.mpvLstShippingAddresses.length > 0) {
				state.mpvLstShippingAddresses.forEach(shippingAddress => {
					url += `&lstShippingAddresses=${encodeURIComponent(shippingAddress)}`
				})
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstMpv", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
	},
}
